import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyAPsaqzpCIZa5Vec6S0wN4CQLLBM1jqS28",
  authDomain: "staff-tracking-45891.firebaseapp.com",
  projectId: "staff-tracking-45891",
  storageBucket: "staff-tracking-45891.firebasestorage.app",
  messagingSenderId: "433563825223",
  appId: "1:433563825223:web:7b5d45f4b58a268fc96d62",
  measurementId: "G-M6K1M35LYM",
};

const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const auth = getAuth(app);
const firestoreDb = getFirestore(app);
const googleProvider = new GoogleAuthProvider();

export { auth, googleProvider, analytics, firestoreDb };
export default app;
